export default "__VITE_ASSET__CWevIQzI__"